import { motion } from "framer-motion";
import { NATIONAL } from "@/data/news";

export default function NationalGrid({ items }) {
  const data = items && items.length ? items : NATIONAL;
  const lead = data.find((n) => n.lead) || data[0];
  const rest = data.filter((n) => n.id !== lead.id);

  return (
    <section
      id="national"
      data-testid="national-section"
      className="bg-[#F4F4F0]"
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
          <div>
            <div className="eyebrow text-[#D92525] mb-3">देश-दुनिया</div>
            <h2 className="font-serif-dev font-black text-[38px] md:text-[52px] leading-[1.02]">
              नेशनल <span className="italic text-[#4A4A4A]">डेस्क</span>
            </h2>
          </div>
          <a href="/category/national" data-testid="national-more" className="font-sans-dev text-[12px] tracking-[0.24em] uppercase link-underline">
            सभी नेशनल →
          </a>
        </div>

        <div className="grid grid-cols-12 md:col-divider gap-6 md:gap-0 border-t border-b border-[#0F0F0F]/25 py-8">
          <motion.a
            href={lead.slug ? `/news/${lead.slug}` : "#"}
            data-testid={`national-lead-${lead.id}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="col-span-12 md:col-span-6 md:pr-8 group block"
          >
            <div className="thumb-wrap aspect-[16/10] mb-5">
              <img src={lead.img} alt={lead.title} className="w-full h-full object-contain" />
            </div>
            <div className="eyebrow text-[#D92525] mb-2">{lead.kicker} · {lead.time}</div>
            <h3 className="font-serif-dev font-black text-[26px] md:text-[34px] leading-[1.1] headline-link">
              {lead.title}
            </h3>
          </motion.a>

          {rest.map((n, i) => (
            <motion.a
              key={n.id}
              href={n.slug ? `/news/${n.slug}` : "#"}
              data-testid={`national-item-${n.id}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: 0.1 + i * 0.08 }}
              className={`col-span-12 md:col-span-2 md:px-5 group block`}
            >
              <div className="thumb-wrap aspect-[4/3] mb-4">
                <img src={n.img} alt={n.title} className="w-full h-full object-contain" />
              </div>
              <div className="eyebrow text-[#D92525] mb-1.5">{n.kicker} · {n.time}</div>
              <h4 className="font-serif-dev font-bold text-[16px] md:text-[17px] leading-snug headline-link">
                {n.title}
              </h4>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
